<template>
    <div class="hidden">
        {{logout()}}
    </div>
</template>


<script>
export default {
    data(){
        return{
            
        }
    },  
    methods: {
        async logout(){
            await this.$store.dispatch('LogOut')
            this.$router.push('/')
        },
    },  
    async beforeCreate(){

    }
}
</script>